import React from "react";
import { Switch, Route } from "react-router-dom";
import InspectionPage from "../inspection/inspetionsPage";
import Details from "../inspection/inspectionDetails";
import InspectionList from "../inspection/inspectionList";
const InspectionsRoute = props => {
  let { history } = props;
  return (
    <Switch>
      <Route
        exact
        path="/new/:it"
        history={history}
        component={InspectionPage}
      />
      <Route
        exact
        path="/new/details/:id"
        history={history}
        component={Details}
      />
      {/* InspectionList */}
      {/* <Route
                exact
                path="/inspection/edit/:id"
                history={history}
                component={EditInspection}
            /> */}
      <Route
        exact
        path="/new/start/inspection/:id"
        history={history}
        component={InspectionList}
      />
    </Switch>
  );
};

export default InspectionsRoute;



// WEBPACK FOOTER //
// ./src/inspection/inspectionRoutes.jsx